<template>
  <a-tooltip title="Report sorty's behaviour" placement="bottom">
    <button
      type="button"
      :class="buttonClass"
      aria-label="Report sorty's behaviour"
      @click="emit('click')"
    >
      <FlagIcon :class="iconClass" />
    </button>
  </a-tooltip>
</template>

<script setup>
import { FlagIcon } from 'lucide-vue-next';

// The icon never stays filled: a student can report again in the same chat.
defineProps({
  buttonClass: {
    type: String,
    default:
      'p-1 cursor-pointer hover:bg-black/10 rounded text-indigo-100 hover:text-white transition-colors outline-none focus-visible:ring-1 focus-visible:ring-white/70',
  },
  iconClass: { type: String, default: 'w-3.5 h-3.5' },
});
const emit = defineEmits(['click']);
</script>
